import { Type } from '@angular/core';
import { URL_CONSTANTS } from 'src/app/common/utils/url';
import { AnalyticsInsightAlertEntity } from '../../models/alert';
import { RelatedSpaceComponent } from '../alert-details/related-space/related-space.component';
import { AlertPrimaryAction } from './alert.view-model';
import { SpaceAlertViewModel } from './space-alert.view-model';

export class NudityAlertViewModel extends SpaceAlertViewModel<AnalyticsInsightAlertEntity> {
  get title(): string {
    if (this.isSpaceDeleted) {
      return this.translateService.instant('Potential Nudity Detected');
    }

    return this.translateService.instant('Potential Nudity Detected: {{spaceName}}', {
      spaceName: this.spaceName,
    });
  }

  override get relatedComponentType(): Type<unknown> | null {
    return RelatedSpaceComponent;
  }

  override get alertTypeLabel(): string {
    return this.translateService.instant('Nudity');
  }

  override get primaryAction(): AlertPrimaryAction | null {
    return {
      label: this.translateService.instant('View issue'),
      icon: 'open_in_new',
      execute: () => window.open(`/${URL_CONSTANTS.RECORDINGS}`, '_blank'),
    };
  }
}
